import React from 'react';
import CountUp from 'react-countup';

const Percentage = React.memo(({ value, count = false }) => {
  const numeric = parseFloat(value);
  if (isNaN(numeric)) return null;

  const isInteger = Number.isInteger(numeric);
  const displayValue = isInteger ? numeric : Math.round(numeric);

  if (count) {
    return (
      <CountUp
        end={displayValue}
        duration={1.5}
        suffix="%"
        decimals={0}
      />
    );
  }

  return <>{isInteger ? `${displayValue}%` : `~${displayValue}%`}</>;
});

export default Percentage;
